import {
  changedAppIconAnalytics,
  clickedAnalyticsAction,
  clickedToUploadProfilePhotoAnalytics,
  selectPredefinedProfilePhotoAnalytics,
  uploadProfilePhotoAnalytics,
} from '@bridebook/web/lib/settings/analytics/actions';

export enum SettingsAnalyticsActionTypes {
  OPEN_APP_VERSION_POPUP_ANALYTICS = '[Analytics] Open app version popup',
  USER_UPLOAD_PROFILE_PHOTO_ANALYTICS = '[Analytics] User upload profile photo',
  USER_DELETE_PROFILE_PHOTO_ANALYTICS = '[Analytics] User delete profile photo',
  USER_CLICKED_DELETE_ACCOUNT_ANALYTICS = '[Analytics] Clicked delete account',
  USER_CHANGED_APP_ICON_ANALYTICS = '[Analytics] User changed app icon',
  USER_CLICKED_UPLOAD_PROFILE_PHOTO_ANALYTICS = '[Analytics] User clicked upload profile photo',
  USER_SELECTED_PREDEFINED_PROFILE_PHOTO = '[Analytics] User selected predefined profile photo',
  CLICKED_ANALYTICS_ACTION = '[Analytics] Clicked analytics action',
  TRIGGERED_INTERCEPT_POPUP = '[Analytics] Triggered intercept popup',
}

export type ChangedAppIconAnalyticsAction = ReturnType<typeof changedAppIconAnalytics>;

export type ClickedToUploadProfilePhotoAnalytics = ReturnType<
  typeof clickedToUploadProfilePhotoAnalytics
>;

export type UploadProfilePhotoAnalytics = ReturnType<typeof uploadProfilePhotoAnalytics>;

export type SelectPredefinedProfilePhotoAnalytics = ReturnType<
  typeof selectPredefinedProfilePhotoAnalytics
>;

export type ClickedAnalyticsAction = ReturnType<typeof clickedAnalyticsAction>;
